import React, { useRef, useEffect } from "react";
import { Badge } from "@/components";
import "./BadgeList.css";

interface TabOption {
  key: string;
  label: string;
  count: number;
}

interface BadgeListProps {
  tabs: TabOption[];
  activeTab: string;
  onTabChange: (key: any) => void;
}

const BadgeList: React.FC<BadgeListProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const activeElement = scrollRef.current?.querySelector(
      ".is-active",
    ) as HTMLElement;

    if (activeElement && scrollRef.current) {
      const container = scrollRef.current;

      const scrollLeft =
        activeElement.offsetLeft -
        container.offsetWidth / 2 +
        activeElement.offsetWidth / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }
  }, [activeTab]);

  return (
    <div className="badge-list" ref={scrollRef}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`badge-btn ${activeTab === tab.key ? "is-active" : ""}`}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
          {tab.count > 0 && <Badge number={tab.count} />}
        </button>
      ))}
    </div>
  );
};

export default BadgeList;
